<template>
  <div>
    <div class="rate-period-container table-contract-container">
      <table style="border: none; table-layout:fixed; position: relative" width="100%">
        <tr>
          <td style="width: 300px; vertical-align: bottom; padding-bottom: 15px">
            <el-row
              v-for="(period, index) in periodList" :key="index">
              <el-col :span="4" style="text-align: right; padding-right: 10px">
                <label v-if="index === 0" style="font-size: 14px; color: #606266">{{ $t('period') }}</label>
                <label v-if="index > 0">
                  <i class="el-icon-remove"
                     style="color: red"
                     @click="onRemovePeriodButtonClick(index)"></i>
                </label>
              </el-col>
              <el-col :span="20">
                <el-date-picker size="small"
                                v-model="periodList[index]"
                                type="daterange"
                                format="d MMM yyyy"
                                value-format="yyyy-MM-dd"
                                start-placeholder="From"
                                end-placeholder="To"
                                @change="onDatePickerChange(index)">
                </el-date-picker>
              </el-col>
            </el-row>
          </td>
          <td style="position: relative">
            <div class="allotment-panel-cover-head"></div>
            <div class="allotment-panel">
              <el-row>
                <el-col :span="24" style="text-align: right; padding-right: 10px">
                  <el-dropdown
                    v-if="filterRoomTypeList().length > 0"
                    @command="onAddRoomTypeButtonClick"
                    style="margin-right: 10px">
                    <el-button type="default" size="mini">
                      <i class="el-icon-plus"></i>{{ $t('addRoom') }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="(roomType, roomTypeIndex) in filterRoomTypeList()"
                        :key="roomTypeIndex"
                        :command="roomType.id">
                        {{ (roomType.isEnable === STATUS.ENABLE) ? '' : `[${$t('STATUS.DISABLE')}]` }} {{roomType.name}}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-button type="default"
                             size="mini"
                             @click="goToLeft()"
                             style="padding: 7px 7px">
                    <i class="el-icon-arrow-left"></i>
                  </el-button>
                  <el-button type="default"
                             size="mini"
                             @click="goToRight()"
                             style="padding: 7px 7px">
                    <i class="el-icon-arrow-right"></i>
                  </el-button>
                </el-col>
              </el-row>
              <div class="allotment-container"
                   ref="divRooms"
                   id="divRooms">
                <table style="vertical-align: bottom;">
                  <tr>
                    <td class="room-type-column"
                        style="font-size: 12px;">
                      <strong>Cutoff Date</strong>
                    </td>
                    <td v-for="roomType of selectedRoomTypeList"
                        :key="roomType.id"
                        class="room-type-column">
                      <table cellpadding="0" cellspacing="0" border="0">
                        <tr>
                          <td valign="bottom"
                              style="width: 20px; vertical-align: bottom">
                            <i class="el-icon-remove"
                               style="color: red"
                               @click="onRemoveRoomTyeButtonClick(roomType.id)"></i>
                          </td >
                          <td style="font-size: 11px;">
                            {{roomType.name}}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
                <div v-for="(period, index) in periodList"
                     :key="index"
                     style="margin-top: 8px">
                  <table cellpadding="0" cellspacing="0">
                    <tr>
                      <td class="room-type-column">
                        <div class="el-input el-input--small">
                          <input placeholder="-"
                                 type="number"
                                 v-model="cutOffDateByPeriodList[index]"
                                 class="allotment el-input__inner"
                                 @change="onCutOffDateChange"/>
                        </div>
                      </td>
                      <td v-for="roomType of selectedRoomTypeList" :key="`${roomType.id}-${index}`"
                          class="room-type-column">
                        <div class="el-input el-input--small">
                          <input placeholder="-"
                                 type="number"
                                 class="allotment el-input__inner"
                                 v-model="allotmentByRoomByPeriodList[roomType.id][index]"
                                 @change="onAllotmentChange"/>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="allotment-panel-cover-bottom"></div>
          </td>
        </tr>
        <tr>
          <td>
            <el-row>
              <el-col :span="4"> &nbsp;</el-col>
              <el-col :span="20">
                <el-button type="info"
                           @click="onAddPeriodButtonClick"
                           size="mini"
                           style="width: 100%">
                  <i class="el-icon-plus"></i>
                  {{ $t('addPeriod') }}
                </el-button>
              </el-col>
            </el-row>
          </td>
          <td>
            &nbsp;
          </td>
        </tr>
      </table>
    </div>
    <remark-component
      :remark-type="REMARK_TYPE.ALLOTMENT"
      :is-show-default-button="isShowDefaultButton"
      :contract-detail="contractDetail"
      @onRemarkChange="onRemarkChange">
    </remark-component>
  </div>
</template>
<script>
import { STATUS, REMARK_TYPE } from '@/configs/constant'
import RemarkComponent from '@/views/Contract/components/RemarkComponent'
import i18nMessages from '@/translations/Contract/components/TabContractAllotment'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import { getISODateFormat, getValidPeriodList, periodOverlap, preparePeriodList } from '@/helpers/index'
import { get } from 'lodash'
import { applyNewRemark } from '@/domains/contract-domain'

export default {
  name: 'TabAllotmentComponent',
  mixins: [AlertViewMixin],
  components: { RemarkComponent },
  model: {
    prop: 'contractDetail',
    event: 'onAllotmentListChange'
  },
  i18n: { messages: i18nMessages },
  props: {
    contractDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    roomTypeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  created: function () {
    this.prepareRoomTyeListById()
    this.preparePeriodDataList()
  },
  data () {
    return {
      REMARK_TYPE,
      STATUS,
      isShowDefaultButton: false,
      defaultRemarkList: [],
      newRemark: {},
      periodList: [],
      allotmentByRoomByPeriodList: {},
      cutOffDateByPeriodList: [],
      selectedRoomTypeList: [],
      roomTypeListById: {}
    }
  },
  methods: {
    preparePeriodDataList: function () {
      const periodKeyList = []
      const allotmentList = get(this.contractDetail, 'allotmentList', [])
      for (let allotmentItem of allotmentList) {
        const startDate = getISODateFormat(new Date(allotmentItem.startDate))
        const endDate = getISODateFormat(new Date(allotmentItem.endDate))
        const periodKey = `${startDate}_${endDate}`
        if (!periodKeyList.includes(periodKey)) {
          periodKeyList.push(periodKey)
          this.periodList.push([startDate, endDate])
          this.cutOffDateByPeriodList.push('')
        }
      }
      const selectedRoomTypeItemList = this.prepareSelectedRoomType()
      if (selectedRoomTypeItemList.length > 0) {
        this.selectedRoomTypeList = selectedRoomTypeItemList.sort((a, b) => {
          return (a.name < b.name) ? -1 : 1
        })
        this.prepareAllotment()
      } else {
        this.prepareDefaultAllotment()
      }
      this.prepareCutOffDateList()
    },
    prepareSelectedRoomType: function () {
      const selectedRoomTypeIdList = []
      const selectedRoomTypeItemList = []
      const allotmentList = get(this.contractDetail, 'allotmentList', [])
      for (let allotmentItem of allotmentList) {
        const roomTypeId = allotmentItem.roomTypeId
        const roomTypeName = allotmentItem.roomTypeName
        if (!selectedRoomTypeIdList.includes(roomTypeId)) {
          selectedRoomTypeIdList.push(roomTypeId)
          selectedRoomTypeItemList.push({ id: roomTypeId, name: roomTypeName })
        }
      }

      return selectedRoomTypeItemList
    },
    prepareAllotment: function () {
      const periodKeyList = []
      const allotmentList = get(this.contractDetail, 'allotmentList', [])
      for (let allotmentItem of allotmentList) {
        const startDate = getISODateFormat(new Date(allotmentItem.startDate))
        const endDate = getISODateFormat(new Date(allotmentItem.endDate))
        const roomTypeId = allotmentItem.roomTypeId
        const allotment = allotmentItem.allotment

        const periodKey = `${startDate}_${endDate}`
        if (!periodKeyList.includes(periodKey)) {
          periodKeyList.push(periodKey)
        }
        const periodIndex = periodKeyList.indexOf(periodKey)
        if (this.allotmentByRoomByPeriodList[roomTypeId] === undefined) {
          this.allotmentByRoomByPeriodList[roomTypeId] = new Array(this.periodList.length).fill('')
          this.allotmentByRoomByPeriodList[roomTypeId][periodIndex] = allotment
        } else {
          this.allotmentByRoomByPeriodList[roomTypeId][periodIndex] = allotment
        }
      }
    },
    prepareCutOffDateList: function () {
      const cutOffDateList = get(this.contractDetail, 'cutOffDateList', [])
      for (let item of cutOffDateList) {
        const cutOffStartDate = getISODateFormat(new Date(item.startDate))
        for (let index in this.periodList) {
          if (cutOffStartDate === this.periodList[index][0]) {
            this.cutOffDateByPeriodList[index] = get(item, 'cutOffDate', '')
          }
        }
      }
    },
    prepareDefaultAllotment: function () {
      this.periodList = [['', '']]
      const selectedRoomTypeItemList = []
      for (let roomType of this.roomTypeList) {
        const roomTypeId = roomType.id
        this.allotmentByRoomByPeriodList[roomTypeId] = ['']
        selectedRoomTypeItemList.push({ id: roomType.id, name: roomType.name })
      }
      this.selectedRoomTypeList = selectedRoomTypeItemList.sort((a, b) => {
        return (a.name < b.name) ? -1 : 1
      })
    },
    prepareRoomTyeListById: function () {
      for (let roomTypeItem of this.roomTypeList) {
        const roomTypeId = roomTypeItem.id
        this.roomTypeListById[roomTypeId] = roomTypeItem
      }
    },
    filterRoomTypeList: function () {
      const filterRoomType = this.roomTypeList.filter((roomType) => {
        return (this.allotmentByRoomByPeriodList[roomType.id] === undefined)
      })

      return filterRoomType.sort((a, b) => {
        return (a.name > b.name) ? 1 : -1
      })
    },
    onRemoveRoomTyeButtonClick: function (roomTypeId) {
      this.selectedRoomTypeList = this.selectedRoomTypeList.filter((item) => {
        if (item.id === roomTypeId) {
          return false
        }
        return true
      })
      delete this.allotmentByRoomByPeriodList[roomTypeId]
      this.onAllotmentChange()
    },
    onAddRoomTypeButtonClick: function (roomTypeId) {
      this.allotmentByRoomByPeriodList[roomTypeId] = new Array(this.periodList.length).fill('')
      const roomTypeName = this.roomTypeListById[roomTypeId].name
      this.selectedRoomTypeList.push({ id: roomTypeId, name: roomTypeName })
    },
    onAddPeriodButtonClick: function () {
      this.periodList.push(['', ''])
      this.cutOffDateByPeriodList.push('')
      for (let roomType of this.selectedRoomTypeList) {
        this.allotmentByRoomByPeriodList[roomType.id].push('')
      }
    },
    onRemovePeriodButtonClick: function (index) {
      this.periodList.splice(index, 1)
      for (let roomTyeId in this.allotmentByRoomByPeriodList) {
        this.allotmentByRoomByPeriodList[roomTyeId].splice(index, 1)
      }
      this.onAllotmentChange()
    },
    onDatePickerChange: function (index) {
      const periodList = getValidPeriodList(this.periodList)
      const preparedPeriodList = preparePeriodList(periodList)

      if (periodOverlap(preparedPeriodList) === true) {
        const message = this.$t('alertOverlap')
        this.alertError(message)

        this.periodList[index][0] = ''
        this.periodList[index][1] = ''
      } else {
        this.onAllotmentChange()
      }
    },
    onAllotmentChange: function () {
      const remarkList = applyNewRemark(this.contractDetail, this.newRemark)

      let allotmentList = []

      for (let roomTypeId in this.allotmentByRoomByPeriodList) {
        const allotmentByRoomList = this.allotmentByRoomByPeriodList[roomTypeId]
        const roomTypeName = this.roomTypeListById[roomTypeId].name

        for (let index in allotmentByRoomList) {
          const startDate = get(this.periodList[index], '0', '')
          const endDate = get(this.periodList[index], '1', '')
          const isValidPeriod = (startDate !== '' && endDate !== '')

          if (allotmentByRoomList[index] !== '' && isValidPeriod) {
            const allotmentData = {
              startDate: startDate,
              endDate: endDate,
              roomTypeId: roomTypeId,
              roomTypeName: roomTypeName,
              allotment: allotmentByRoomList[index]
            }
            allotmentList.push(allotmentData)
          }
        }
      }

      const newAllotmentList = {
        allotmentList: allotmentList
      }
      const newRemarkList = {
        remarkList: remarkList
      }

      const contractDetail = Object.assign({}, this.contractDetail, newAllotmentList, newRemarkList)
      this.$emit('onAllotmentListChange', contractDetail)
    },
    onRemarkChange: function (newRemark) {
      this.newRemark = newRemark

      this.onAllotmentChange()
    },
    onCutOffDateChange: function () {
      let cutOffDateList = []
      for (let index in this.cutOffDateByPeriodList) {
        const startDate = get(this.periodList[index], '0', '')
        const endDate = get(this.periodList[index], '1', '')
        const cutOffDateData = {
          startDate: startDate,
          endDate: endDate,
          cutOffDate: this.cutOffDateByPeriodList[index]
        }

        cutOffDateList.push(cutOffDateData)
      }
      const newCutOffDateList = {
        cutOffDateList: cutOffDateList
      }
      const contractDetail = Object.assign({}, this.contractDetail, newCutOffDateList)
      this.$emit('onAllotmentListChange', contractDetail)
    },
    goToRight: function () {
      this.$refs.divRooms.scrollLeft += 100
    },

    goToLeft: function () {
      this.$refs.divRooms.scrollLeft -= 100
    }
  }
}
</script>

<style scoped>
  .el-form > div {
    text-align: left;
  }

  .allotment-panel{
    margin: 0px 20px;
    padding-top: 20px;
    box-shadow:  0px 0px 7px rgba(0,0,0,0.2);
    overflow: hidden;
    position: relative;
  }
  .allotment-panel-cover-head {
    position: absolute;
    top: -2px;
    left: 0px;
    width: 100%;
    height: 15px;
    z-index: 1;
    background-color: rgb(255, 255, 255);
  }

  .allotment-panel-cover-bottom {
    position: absolute;
    bottom: -15px;
    left: 0px;
    width: 100%;
    height: 17px;
    z-index: 1;
    background-color: rgb(255, 255, 255);
  }

  .allotment-container {
    overflow-x: scroll;
    border-top-width: 0px;
    border-bottom-width: 0px;
    padding-bottom: 20px;
  }
  .rate-period-container {
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    padding-left: 50px;
    padding-bottom: 20px;
  }

  .el-date-editor--daterange.el-input__inner {
    width: 100%
  }

  .room-price.el-input__inner {
    text-align: right;
  }
  .disable {
    color: #d2d1d1;
  }
  .room-type-column {
    max-width: 90px;
    min-width: 90px;
    vertical-align: bottom;
    padding-left: 10px;
  }
  .allotment.el-input__inner {
    text-align: right;
    padding: 0px !important;
  }
</style>
